import React, { Component } from 'react';

// Externals
import compose from 'recompose/compose';

// Material helpers
import { withRouter } from 'react-router-dom';
import { Grid } from '@material-ui/core';
import Typography from '@material-ui/core/Typography';
import CircularProgress from '@material-ui/core/CircularProgress';

class WaitServer extends Component {
  render(){
      return (
        <Grid
            item
            xs={12}
            sm={12}
            md={12}
            xl={12}
            style={{textAlign:"center", backgroundColor:"white", marginTop:"100px", height:"40px"}}
            >
            <Typography
                variant="h6"
            >
                <CircularProgress
                variant="indeterminate"

                size={18}
                thickness={3}
                
                />
                Espere un momento se esta realizando la conexión con el servidor...
            </Typography>
        </Grid>
      );
  }
  
}


export default compose(withRouter)(WaitServer);